import { render, staticRenderFns } from "./AdminCommunicationsView.vue?vue&type=template&id=0174612c"
import script from "./AdminCommunicationsView.vue?vue&type=script&lang=ts"
export * from "./AdminCommunicationsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports